import React from "react";
import Section from "../components/Section";
import { Card, Typography } from "../components";

const CardSection = () => {
	return (
		<Section title={"# Cards"}>
			<div className="d-flex flex-wrap gap2">
				<Card className="d-flex" size={"xxl"}>
					<div className="">
						<Typography type="heading" size="lg">
							Card Title - XXL
						</Typography>
						<Typography size="md">Card Content</Typography>
					</div>
				</Card>
				<Card className="d-flex" size={"xl"}>
					<div className="">
						<Typography type="heading" size="md">
							Card Title - XL
						</Typography>
						<Typography>Card Content</Typography>
					</div>
				</Card>
				<Card className="d-flex" size={"lg"}>
					<div className="">
						<Typography type="heading" size="md">
							Card Title - LG
						</Typography>
						<Typography>Card Content</Typography>
					</div>
				</Card>
				<Card className="d-flex" size={"md"}>
					<div className="">
						<Typography type="heading" size="sm">
							Card Title - MD
						</Typography>
						<Typography>Card Content</Typography>
					</div>
				</Card>

				<Card className="d-flex" size={"sm"}>
					<div className="">
						<Typography type="heading" size="sm">
							Card Title - SM
						</Typography>
						<Typography>Card Content</Typography>
					</div>
				</Card>
				<Card className="d-flex" size={"xs"}>
					<div className="">
						<Typography type="heading" size="sm">
							Card Title - XS
						</Typography>
						<Typography>Card Content</Typography>
					</div>
				</Card>
			</div>
		</Section>
	);
};

export default CardSection;
